/*
 * SC Exhibitor booking fields (blocks/sc-exhibitor-booking.liquid) — exhibitor package product page.
 * - Exhibitor type: Private seller (First name + Last name) / Business (Business / Store name). The inactive group is
 *   hidden, disabled (never required, never submitted) and cleared.
 * - Instagram / Website (optional): named only while they hold a value → no empty line item property.
 * - "What do you sell?": the checked options are joined into the hidden properties[Sells] field; at least one
 *   choice is required (custom validity on the first checkbox, so the product form's checkValidity() blocks it).
 * - "Other": shows "Please specify" and makes it required; otherwise hidden, disabled (never submitted), cleared.
 * - Required fields left empty show the translated "required" message (native validation bubble).
 */
(function () {
  function initType(root) {
    var radios = Array.prototype.slice.call(root.querySelectorAll('[data-sc-type]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-sc-type-group]'));
    if (!radios.length || !groups.length) return;

    function update() {
      var active = 'private';
      radios.forEach(function (radio) { if (radio.checked) active = radio.getAttribute('data-sc-type'); });
      groups.forEach(function (group) {
        var on = group.getAttribute('data-sc-type-group') === active;
        group.hidden = !on;
        group.querySelectorAll('input').forEach(function (input) {
          input.disabled = !on;
          if (!on) {
            input.value = '';
            input.setCustomValidity('');
          }
        });
      });
    }

    radios.forEach(function (radio) { radio.addEventListener('change', update); });
    update();
  }

  function initOptional(root) {
    root.querySelectorAll('[data-sc-optional]').forEach(function (input) {
      var name = input.getAttribute('name') || input.getAttribute('data-sc-name');
      if (!name) return;
      input.setAttribute('data-sc-name', name);
      function sync() {
        if (input.value.trim()) input.setAttribute('name', name);
        else input.removeAttribute('name');
      }
      input.addEventListener('input', sync);
      sync();
    });
  }

  function initRequiredMessages(root) {
    var message = root.getAttribute('data-required-message') || '';
    if (!message) return;
    // All text inputs: "Please specify" only becomes required later (Other checked).
    root.querySelectorAll('input[type="text"]').forEach(function (input) {
      input.addEventListener('invalid', function () {
        if (input.validity.valueMissing) input.setCustomValidity(message);
      });
      input.addEventListener('input', function () { input.setCustomValidity(''); });
    });
  }

  function initSells(root) {
    var group = root.querySelector('[data-sc-sells]');
    if (!group) return;
    var boxes = Array.prototype.slice.call(group.querySelectorAll('[data-sc-sell]'));
    var value = group.querySelector('[data-sc-sells-value]');
    var other = group.querySelector('[data-sc-other]');
    var specify = group.querySelector('[data-sc-other-specify]');
    var specifyInput = specify && specify.querySelector('input');
    var mark = specify && specify.querySelector('[data-sc-required-mark]');
    var message = group.getAttribute('data-message') || '';

    function update() {
      var checked = boxes.filter(function (box) { return box.checked; });
      if (value) value.value = checked.map(function (box) { return box.value; }).join(', ');
      if (boxes[0]) boxes[0].setCustomValidity(checked.length ? '' : message);

      var otherOn = !!(other && other.checked);
      if (specify && specifyInput) {
        specify.hidden = !otherOn;
        specifyInput.disabled = !otherOn;
        specifyInput.required = otherOn;
        if (!otherOn) {
          specifyInput.value = '';
          specifyInput.setCustomValidity('');
        }
        if (mark) mark.hidden = !otherOn;
      }
    }

    boxes.forEach(function (box) { box.addEventListener('change', update); });
    update();
  }

  function init(root) {
    if (root.dataset.scBookingReady) return;
    root.dataset.scBookingReady = 'true';
    initType(root);
    initOptional(root);
    initSells(root);
    initRequiredMessages(root);
  }

  function initAll() {
    document.querySelectorAll('[data-sc-booking]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Theme Editor / section re-render
  document.addEventListener('shopify:section:load', initAll);
})();
